import React from 'react';
import CustomSelect from "../../../components/common/select/Select";
import { valueConverter_2 } from '../../../util-functions/util-funtions';


export default function MSKUS(
    {sku_item,
    sku_index,
    item,
    awsBaseline,
    data,
    index,
    selectedSkuNormType,
    enumData,
    collapse_sku,
    baselineChange,
    awsChange,
    post_awsChange,
    handleSkuSlabContChange,
    onKeyDown,
    newProject,
    sku_normChange,
    currentNormTypeChange,
    isExtended,
    formType
}) {
  return (
      <>
      <div className="sku_main">
                                <div className="sku_inner_body">
                                  <div
                                    className="sku_content_div"
                                    style={{ width: "112.4vw" }}
                                  >
                                    <label className="sku_keys">
                                      Master Sku Name
                                  </label>
                                    <label className="sku_val">
                                      {" "}
                                      {sku_item.Description} {item.expanded}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label className="sku_keys">
                                      Master Sku Code
                                  </label>
                                    <label className="sku_val">
                                      {" "}
                                      {sku_item.Code}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {formType === 'ic' ? 'Gp/Litre' :'Gp/Ton'}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {valueConverter_2(sku_item.GpTon)}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label className="sku_keys">
                                      Aws Baseline{" "}
                                    </label>
                                    <label className="sku_baseline">
                                      <input
                                        type="number"
                                        className="other_detail_input"
                                        onChange={(e) =>
                                          baselineChange(e, sku_index, index)
                                        }
                                        name="awsBaseline"
                                        value={
                                          awsBaseline !== "isEmpty"
                                            ? awsBaseline
                                            : sku_item.Baseline
                                        }
                                      />
                                    </label>{" "}
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                    Total Cost{" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {!sku_item.TotalCost
                                        ? 0
                                        : valueConverter_2(sku_item.TotalCost)}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                    Inc Vol{" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {!sku_item.IncVolume
                                        ? 0
                                        : valueConverter_2(sku_item.IncVolume)}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                    Act Duration{" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      {data.ActivityDuration}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      Pricing{" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      {sku_item.Pricing.toFixed(10)}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      Grammage{" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      {sku_item.Grammage.toFixed(10)}{" "}
                                    </label>
                                  </div>
                                  <div className="sku_content_div">
                                    <label
                                      className="sku_keys"
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                    ROI(%){" "}
                                    </label>
                                    <label
                                      className="sku_val"
                                      style={{ textAlign: "center" }}
                                    >
                                      {!sku_item.Roi ? 0 : valueConverter_2(sku_item.Roi)}
                                    </label>
                                  </div>
                                </div>

                                {sku_item.expanded === true && (
                                  <div className="sku_expand_body content">
                                    <div className="sku_expand_div">
                                      <div className="expanded_content">
                                        <label className="sku_keys">
                                          {" "}
                                        Incremental Aws{" "}
                                        </label>
                                        <label className="sku_baseline">
                                          <input
                                            type="number"
                                            className="other_detail_input"
                                            onChange={(e) => {
                                              awsChange(e, sku_index, index);
                                            }}
                                            name="activatedAws"
                                            value={sku_item.ActivatedAws}
                                          />
                                        </label>
                                      </div>
                                      <div className="expanded_content">
                                        <label className="sku_keys">
                                          Total Inc Act Vol
                                      </label>
                                        <label className="sku_val">
                                          {" "}
                                          {valueConverter_2(sku_item.TotalActivatedVolume)}{" "}
                                        </label>
                                      </div>
                                      <div className="expanded_content">
                                        <label
                                          className="sku_keys"
                                          style={{ textAlign: "left" }}
                                        >
                                          {" "}
                                        Post Aws{" "}
                                        </label>
                                        <label className="sku_baseline">
                                          <input
                                            type="number"
                                            className="other_detail_input"
                                            onChange={(e) => {
                                              post_awsChange(
                                                e,
                                                sku_index,
                                                index
                                              );
                                            }}
                                            name="postAws"
                                            value={sku_item.PostAws}
                                          />
                                        </label>
                                      </div>
                                      <div className="expanded_content">
                                        <label
                                          className="sku_keys"
                                          style={{ paddingLeft: "1.7vw" }}
                                        >
                                          {" "}
                                        DNDS Vol{" "}
                                        </label>
                                        <label
                                          className="sku_val"
                                          style={{ paddingLeft: "1.7vw" }}
                                        >
                                          {!sku_item.DndsVolume
                                            ? 0
                                            : valueConverter_2(sku_item.DndsVolume)}
                                          {/* {dnds_total += sku_item.DndsVolume
                        }   */}
                                        </label>
                                      </div>
                                    </div>
                                    {item.Slabs ? (
                                      item.Slabs.length !== 0 ? (
                                        <div className="sku_expand_div">
                                          <div className="expanded_content">
                                            <label className="sku_keys">
                                              Total Vol
                                          </label>
                                            <label className="sku_val">
                                              {!sku_item.TotalVolume
                                                ? 0
                                                : valueConverter_2(sku_item.TotalVolume)}
                                            </label>
                                          </div>
                                          {item.Slabs.length > 0 ? (
                                            <div className="expanded_content">
                                              <label className="sku_keys">
                                                {" "}
                                              Cont 1{" "}
                                              </label>
                                              <label className="sku_val">
                                                {" "}
                                                <input
                                                  className="__contribution"
                                                  value={
                                                    !sku_item.Contributions[0]
                                                      ? 0
                                                      : sku_item.Contributions[0]
                                                  }
                                                  name="slab1"
                                                  onChange={(e) => {
                                                    isExtended===true ? void 0 :
                                                    handleSkuSlabContChange(
                                                      e,
                                                      index,
                                                      sku_index,
                                                      0
                                                    );
                                                  }}
                                                  disabled={isExtended===true?true:false}
                                                  style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}

                                                />{" "}
                                              </label>
                                            </div>
                                          ) : (
                                              void 0
                                            )}
                                          {item.Slabs.length > 1 ? (
                                            <div className="expanded_content">
                                              <label className="sku_keys">
                                                {" "}
                                              Cont 2{" "}
                                              </label>
                                              <label className="sku_val">
                                                {" "}
                                                <input
                                                  className="__contribution"
                                                  value={
                                                    !sku_item.Contributions[1]
                                                      ? 0
                                                      : sku_item.Contributions[1]
                                                  }
                                                  name="slab1"
                                                  onChange={(e) => {
                                                    isExtended===true ? void 0 :
                                                    handleSkuSlabContChange(
                                                      e,
                                                      index,
                                                      sku_index,
                                                      1
                                                    );
                                                  }}
                                                  disabled={isExtended===true?true:false}
                                                  style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                                />{" "}
                                              </label>
                                            </div>
                                          ) : (
                                              void 0
                                            )}

                                          {item.Slabs.length > 2 ? (
                                            <div className="expanded_content">
                                              <label className="sku_keys">
                                                {" "}
                                              Cont 3{" "}
                                              </label>
                                              <label className="sku_val">
                                                {" "}
                                                <input
                                                  className="__contribution"
                                                  value={
                                                    !sku_item.Contributions[2]
                                                      ? 0
                                                      : sku_item.Contributions[2]
                                                  }
                                                  name="slab2"
                                                  onChange={(e) => {
                                                    isExtended===true ? void 0 :
                                                    handleSkuSlabContChange(
                                                      e,
                                                      index,
                                                      sku_index,
                                                      2
                                                    );
                                                  }}
                                                  disabled={isExtended===true?true:false}
                                                  style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                                />{" "}
                                              </label>
                                            </div>
                                          ) : (
                                              void 0
                                            )}
                                          {item.Slabs.length > 3 ? (
                                            <div className="expanded_content">
                                              <label className="sku_keys">
                                                {" "}
                                              Cont 4{" "}
                                              </label>
                                              <label className="sku_val">
                                                {" "}
                                                <input
                                                  className="__contribution"
                                                  value={
                                                    !sku_item.Contributions[3]
                                                      ? 0
                                                      : sku_item.Contributions[3]
                                                  }
                                                  name="slab3"
                                                  onChange={(e) => {
                                                    isExtended===true ? void 0 :
                                                    handleSkuSlabContChange(
                                                      e,
                                                      index,
                                                      sku_index,
                                                      3
                                                    );
                                                  }}
                                                  disabled={isExtended===true?true:false}
                                                  style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                                />
                                              </label>
                                            </div>
                                          ) : (
                                              void 0
                                            )}
                                          {item.Slabs.length > 4 ? (
                                            <div className="expanded_content">
                                              <label className="sku_keys">
                                                {" "}
                                              Cont 5{" "}
                                              </label>
                                              <label className="sku_val">
                                                {" "}
                                                <input
                                                  className="__contribution"
                                                  value={
                                                    !sku_item.Contributions[4]
                                                      ? 0
                                                      : sku_item.Contributions[4]
                                                  }
                                                  name="slab4"
                                                  onChange={(e) => {
                                                    isExtended===true ? void 0 :
                                                    handleSkuSlabContChange(
                                                      e,
                                                      index,
                                                      sku_index,
                                                      4
                                                    );
                                                  }}
                                                  disabled={isExtended===true?true:false}
                                                  style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                                />{" "}
                                              </label>
                                            </div>
                                          ) : (
                                              void 0
                                            )}
                                          <div className="expanded_content">
                                            <label
                                              className="sku_keys"
                                              style={{ textAlign: "left", }}
                                            >
                                              {" "}
                                            Norm(%){" "}
                                            </label>
                                            <label className="sku_baseline">
                                              {!sku_item.Norm
                                                ? 0
                                                : valueConverter_2(sku_item.Norm)}
                                            </label>
                                          </div> 
                                        </div>
                                      ) : (
                                          void 0
                                        )
                                    ) : (
                                        <div className="sku_expand_div">
                                          <div className="expanded_content">
                                            <label className="sku_keys">
                                              Total Vol
                                        </label>
                                            <label className="sku_val">
                                              {!sku_item.TotalVolume
                                                ? 0
                                                : valueConverter_2(sku_item.TotalVolume)}
                                            </label>
                                          </div>

                                          <div className="expanded_content">
                                            <label className="sku_keys">
                                              {" "}
                                          Org Norm{" "}
                                            </label>
                                            <label className="sku_val">
                                              {" "}
                                              {valueConverter_2(sku_item.OrgNorm)}
                                            </label>
                                          </div>
                                          <div className="expanded_content">
                                            <label
                                              className="sku_keys"
                                              style={{ textAlign: "left" }}
                                            >
                                              {" "}
                                          Norm{" "}
                                            </label>
                                            <label className="sku_baseline">
                                              <input
                                                type="number"
                                                className="other_detail_input"
                                                onKeyDown={onKeyDown}
                                                onChange={(e) => {
                                                  isExtended===true?void 0 :
                                                  item.SkuVolumeAnalysis.length > 1
                                                    ? newProject(
                                                      e,
                                                      sku_index,
                                                      index,
                                                      item,
                                                      true
                                                    )
                                                    : sku_normChange(
                                                      e,
                                                      index,
                                                      sku_index
                                                    );
                                                }}
                                                name="skuNorm"
                                                value={sku_item.Norm}
                                                disabled={(isExtended===true || formType === 'ic')?true:false}
                                                style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                              />
                                            </label>
                                          </div>
                                          <div className="expanded_content">
                                            <label
                                              className="sku_keys"
                                              style={{ paddingLeft: "1vw" }}
                                            >
                                              {" "}
                                          Norm Delta{" "}
                                            </label>
                                            <label
                                              className="sku_val"
                                              style={{ paddingLeft: "1vw" }}
                                            >
                                              {" "}
                                              {sku_item.Percentage}{" "}
                                            </label>
                                          </div>
                                          <div className="expanded_content">
                                            <label className="sku_keys">
                                              {" "}
                                          Norm Type{sku_item.expanded}{" "}
                                            </label>
                                            <label className="sku_baseline">
                                              <CustomSelect.MySelect
                                              isDisabled={(isExtended===true || formType === 'ic')?true:false}
                                                placeholder="Norm Type"
                                                options={
                                                  enumData
                                                    ? enumData
                                                      .filter((filter_item) => {
                                                        return (
                                                          filter_item.Type ===
                                                          "DISCOUNT_TYPE"
                                                        );
                                                      }).filter(for_freesku => {
                                                        return for_freesku.guid !== 'b2e41bb3-a11d-48f1-b041-b9c04c956e7a'
                                                      })
                                                      .map((map_item) => {
                                                        return {
                                                          value: map_item.guid,
                                                          label: map_item.Label,
                                                        };
                                                      })
                                                    : []
                                                }
                                                value={
                                                  enumData
                                                    ? enumData
                                                      .filter((filter_item) => {
                                                        return selectedSkuNormType ===
                                                          ""
                                                          ? filter_item.guid ===
                                                          item.NormType
                                                          : filter_item.guid ===
                                                          selectedSkuNormType;
                                                      })
                                                      .map((map_item) => {
                                                        return {
                                                          value: map_item.guid,
                                                          label: map_item.Label,
                                                        };
                                                      })
                                                    : void 0
                                                }
                                                // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                                onChange={(val) => {
                                                  item.SkuVolumeAnalysis.length > 1
                                                    ? newProject(
                                                      val,
                                                      sku_index,
                                                      index,
                                                      item
                                                    )
                                                    : currentNormTypeChange(
                                                      val,
                                                      index
                                                    );
                                                }}
                                              />
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )}

                                <div className="sku_right_arrow collapsible">
                                  <img
                                    src={
                                      sku_item.expanded === true
                                        ? require("../../gt/images/arrowUp.svg")
                                        : require("../../gt/images/arrowDown.svg")
                                    }
                                    onClick={()=>collapse_sku(
                                      sku_index,
                                      index
                                    )}
                                    alt=''
                                  />
                                </div>
                              </div>
                          
      </>
  );
}
